var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapView01 = function SvgMapView01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "map_view-01_svg2__a",
    x1: 31.13,
    x2: 159.51,
    y1: 162.95,
    y2: 24.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a80096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#map_view-01_svg2__a",
    id: "map_view-01_svg2__b",
    x1: 49.28,
    x2: 177.65,
    y1: 179.81,
    y2: 41.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#map_view-01_svg2__a",
    id: "map_view-01_svg2__c",
    x1: -22.03,
    x2: 106.35,
    y1: 113.56,
    y2: -24.61
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#map_view-01_svg2__a",
    id: "map_view-01_svg2__d",
    x1: -18.59,
    x2: 109.79,
    y1: 116.75,
    y2: -21.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#map_view-01_svg2__a",
    id: "map_view-01_svg2__e",
    x1: 47.9,
    x2: 176.28,
    y1: 178.53,
    y2: 40.37
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M92.38 168.16c41.38 0 75.05-33.67 75.05-75.05s-33.67-75.04-75.05-75.04h-.75a2.95 2.95 0 0 0-2.91 2.97 2.943 2.943 0 0 0 2.93 2.91h.72c15.53 0 29.88 5.14 41.43 13.82L102.83 80.1H69.42c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h34.9c.94 0 1.82-.45 2.37-1.2l31.65-43.27c2.6 2.32 5.03 4.83 7.26 7.51l-23.62 32.29a2.938 2.938 0 0 0 2.37 4.67h36.83c.24 2.36.37 4.75.37 7.17 0 1.05-.03 2.09-.07 3.12h-22.67c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h22.16c-1.99 15.25-8.97 28.96-19.24 39.43h-36.12c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h29.6c-11.79 9.32-26.67 14.89-42.83 14.89s-31.04-5.57-42.83-14.89h32.11c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93H43.02a70 70 0 0 1-3.85-4.26l25.73-35.16h61.41c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93h-62.9c-.94 0-1.82.45-2.37 1.2l-25.57 34.95a69.5 69.5 0 0 1-5.63-9.73l15.91-21.75a2.938 2.938 0 0 0-2.37-4.67H23.27c-.05-1.04-.07-2.08-.07-3.12 0-2.41.13-4.8.37-7.17h10.9c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93H24.43c.74-3.85 1.8-7.64 3.19-11.34.57-1.52-.2-3.21-1.71-3.78s-3.21.2-3.78 1.71a74.8 74.8 0 0 0-4.8 26.44c0 41.38 33.67 75.05 75.05 75.05Zm37.77-88.08 19.17-26.21a68.8 68.8 0 0 1 11 26.21h-30.18ZM37.6 102.11l-10.39 14.21a68.6 68.6 0 0 1-3.42-14.21h13.82Z",
    style: {
      fill: "url(#map_view-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.45 176.12-29.06-29.06c11.28-15.61 17.37-34.31 17.37-53.95 0-24.68-9.61-47.88-27.06-65.32C140.26 10.34 117.06.73 92.38.73c-3.78 0-7.61.24-11.39.7-1.61.2-2.75 1.66-2.55 3.27s1.66 2.75 3.27 2.55c3.54-.43 7.13-.65 10.67-.65 23.11 0 44.83 9 61.18 25.34 16.34 16.34 25.34 38.07 25.34 61.18s-9 44.83-25.34 61.18c-16.34 16.34-38.07 25.34-61.18 25.34s-44.83-9-61.17-25.34S5.87 116.23 5.87 93.12c0-14.36 3.59-28.58 10.38-41.12a2.94 2.94 0 0 0-1.18-3.98 2.94 2.94 0 0 0-3.98 1.18C3.83 62.6 0 77.79 0 93.12 0 117.8 9.61 141 27.06 158.44c17.45 17.45 40.65 27.06 65.32 27.06 20.35 0 39.69-6.54 55.63-18.62l8.78 8.78a2.946 2.946 0 0 0 4.16 0c1.15-1.15 1.15-3 0-4.15l-8.34-8.34a99 99 0 0 0 5.1-4.73c2.14-2.14 4.17-4.38 6.07-6.69l28.52 28.52c1.18 1.18 1.83 2.75 1.83 4.41s-.65 3.23-1.83 4.41l-2.47 2.47c-1.18 1.18-2.75 1.83-4.41 1.83s-3.23-.65-4.41-1.83l-11.21-11.21c-1.15-1.15-3-1.15-4.15 0s-1.15 3 0 4.15l11.21 11.21c2.29 2.29 5.33 3.55 8.56 3.55s6.28-1.26 8.56-3.55l2.47-2.47c2.29-2.29 3.55-5.33 3.55-8.56s-1.26-6.28-3.55-8.56",
    style: {
      fill: "url(#map_view-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.96 14.72c-5.58 0-10.87 2.42-14.52 6.64a19.2 19.2 0 0 0-4.69 12.57c0 10.59 8.62 19.21 19.21 19.21 5.58 0 10.87-2.42 14.52-6.64 3.02-3.49 4.69-7.95 4.69-12.57 0-10.59-8.62-19.21-19.21-19.21m10.08 27.94a13.34 13.34 0 0 1-10.09 4.61c-7.36 0-13.34-5.98-13.34-13.34a13.336 13.336 0 0 1 13.34-13.34c7.36 0 13.34 5.99 13.34 13.34 0 3.21-1.15 6.31-3.25 8.73",
    style: {
      fill: "url(#map_view-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.05 72.25c2 2.76 3.38 5.84 4.1 9.17l1.02 4.7c.79 3.64 4.07 6.29 7.79 6.29s7.01-2.65 7.8-6.29l1.02-4.7c.72-3.33 2.1-6.42 4.1-9.17l4.26-5.88a2.94 2.94 0 0 0-.65-4.1 2.94 2.94 0 0 0-4.1.65l-4.26 5.88a30.1 30.1 0 0 0-5.08 11.38l-1.02 4.7c-.21.96-1.07 1.66-2.06 1.66s-1.85-.7-2.06-1.66l-1.02-4.7c-.89-4.13-2.6-7.96-5.08-11.38L30.22 50.06c-3.49-4.69-5.33-10.27-5.33-16.14 0-7.35 2.9-14.24 8.16-19.38s12.21-7.87 19.58-7.7c6.98.16 13.57 3.02 18.54 8.03s7.77 11.62 7.88 18.61c.1 6.03-1.75 11.76-5.35 16.6l-1.91 2.63a2.94 2.94 0 0 0 .65 4.1c1.31.95 3.15.66 4.1-.65l1.89-2.61c4.36-5.87 6.6-12.84 6.49-20.17-.13-8.51-3.54-16.55-9.58-22.65C69.29 4.64 61.28 1.17 52.77.97c-8.96-.21-17.41 3.12-23.81 9.37s-9.93 14.63-9.93 23.57c0 7.13 2.24 13.93 6.47 19.61l13.57 18.71Z",
    style: {
      fill: "url(#map_view-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.64 150.96c1.62 0 2.93-1.31 2.93-2.93v-11.55c5.41-1.32 9.44-6.21 9.44-12.02 0-6.82-5.55-12.38-12.38-12.38s-12.38 5.55-12.38 12.38c0 5.81 4.03 10.7 9.44 12.02v11.55c0 1.62 1.31 2.93 2.93 2.93Zm-6.51-26.51c0-3.59 2.92-6.51 6.51-6.51s6.51 2.92 6.51 6.51-2.92 6.51-6.51 6.51-6.51-2.92-6.51-6.51",
    style: {
      fill: "url(#map_view-01_svg2__e)"
    }
  }));
};
export default SvgMapView01;